import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import SearchFormBottom from './SearchFormBottom/SearchFormBottom';
import SearchFormHeader from './SearchFormHeader/SearchFormHeader';
import CarsPanel from './CarsPanel';
import MotoPanel from './MotoPanel';
import CommercialPanel from './CommercialPanel';
import DealersPanel from './DealersPanel';
import SparesPanel from './SparesPanel';
import history from '../../../history';
import s from './SearchPanel.css';

class SearchPanel extends React.Component {
  static propTypes = {
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    formResults: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    formData: PropTypes.shape().isRequired,
    transportType: PropTypes.shape().isRequired,
    handleClearForm: PropTypes.func.isRequired,
    getSearchUrl: PropTypes.func.isRequired,
    page: PropTypes.string.isRequired,
    age: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
      }),
    ).isRequired,
    expandable: PropTypes.bool,
    searchable: PropTypes.bool,
    count: PropTypes.number,
    withLocation: PropTypes.bool,
    isLoading: PropTypes.bool,
    cardTypes: PropTypes.string,
    setAge: PropTypes.func,
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    expandable: true,
    searchable: true,
    withLocation: true,
    isLoading: false,
    count: 0,
    cardTypes: undefined,
    setAge: null,
  };

  state = {
    collapsed: true,
    type: 'all',
    region: 'all',
  };

  setAge = age => {
    this.props.selectedActions.set.isNew(age.id);
    this.props.formState.isNew = age.id;
    history.push(this.props.getSearchUrl(this.props.formState));
  };

  toggleCollapse = () => {
    this.setState(prevState => ({
      collapsed: !prevState.collapsed,
    }));
  };

  render() {
    const {
      formState,
      handleClearForm,
      getSearchUrl,
      page,
      formData = {},
      formResults = {},
      formVocabulary,
      cardTypes,
      expandable,
      age,
      searchable,
      withLocation,
      isLoading,
      count,
      intl,
    } = this.props;

    const newCount = formResults['dealers-AJAX'] && formResults['dealers-AJAX'].count;
    const { collapsed, region, type } = this.state;
    const url = getSearchUrl(formState);
    const defaultCardType = intl.formatMessage(
      {
        id: 'объявления',
      },
      {
        count: count % 100 > 19 ? count % 10 : count % 100,
      },
    );

    return (
      <div className={s.root}>
        <SearchFormHeader
          isNew={page.toLowerCase() === 'dealers' ? formState.hasNew : formState.isNew}
          withLocation={withLocation}
          locations={formVocabulary.locations}
          regionId={region}
          setAge={this.props.setAge || this.setAge}
          age={age}
        />
        {(() => {
          switch (page.toLowerCase()) {
            case 'dealers': {
              return <DealersPanel {...this.props} collapsed={collapsed} />;
            }
            case 'spares': {
              return <SparesPanel {...this.props} collapsed={collapsed} />;
            }
            case 'moto-search': {
              return <MotoPanel {...this.props} collapsed={collapsed} />;
            }
            case 'commercial': {
              return <CommercialPanel {...this.props} collapsed={collapsed} />;
            }
            case 'search': {
              return <CarsPanel {...this.props} collapsed={collapsed} />;
            }
            default: {
              return <CarsPanel {...this.props} collapsed={collapsed} />;
            }
          }
        })()}

        <SearchFormBottom
          count={count}
          collapsed={collapsed}
          type={type}
          url={url}
          expandable={expandable}
          searchable={searchable}
          handleClick={this.toggleCollapse}
          handleClearForm={handleClearForm}
          cardTypes={cardTypes || defaultCardType}
          isLoading={isLoading}
        />
      </div>
    );
  }
}
const mapStateToProps = ({ searchForm = {} }) => ({
  formResults: searchForm.results,
  count: searchForm.data.count,
});
export default withStyles(s)(connect(mapStateToProps)(injectIntl(SearchPanel)));



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanel/SearchPanel.js